import React from 'react'

import { IconButton, Tooltip } from '@mui/material'
import { originalIcons } from '@shared/components/icons/icons'

type Props = {
  description: NonNullable<React.ReactNode>
  interactive?: boolean
}

export function InfoTooltip(props: Props) {
  return (
    <Tooltip title={props.description} disableInteractive={!props.interactive}>
      <IconButton edge="end" size="small">
        <originalIcons.InfoIcon />
      </IconButton>
    </Tooltip>
  )
}
